"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _style = _interopRequireDefault(require("./style.css"));
var _questAdmin = _interopRequireDefault(require("./questAdmin.graphql"));
var _questProject = _interopRequireDefault(require("./questProject.graphql"));
var _cccisdApollo = require("cccisd-apollo");
var _cccisdAxios = _interopRequireDefault(require("cccisd-axios"));
var _cccisdFormik = require("cccisd-formik");
var _cccisdToggle = _interopRequireDefault(require("cccisd-toggle"));
var _palette = _interopRequireDefault(require("cccisd-icons/palette"));
var _paperplane = _interopRequireDefault(require("cccisd-icons/paperplane"));
var _meterMedium = _interopRequireDefault(require("cccisd-icons/meter-medium"));
var _listNumbered = _interopRequireDefault(require("cccisd-icons/list-numbered"));
var _fileSpreadsheet = _interopRequireDefault(require("cccisd-icons/file-spreadsheet2"));
var _cog = _interopRequireDefault(require("cccisd-icons/cog2"));
var _copy = _interopRequireDefault(require("cccisd-icons/copy3"));
var _userCheck = _interopRequireDefault(require("cccisd-icons/user-check"));
var _stackPlus = _interopRequireDefault(require("cccisd-icons/stack-plus"));
var _pencil = _interopRequireDefault(require("cccisd-icons/pencil"));
var _checkmark = _interopRequireDefault(require("cccisd-icons/checkmark"));
var _cccisdTooltip = _interopRequireDefault(require("cccisd-tooltip"));
var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));
var _cccisdNotification = _interopRequireDefault(require("cccisd-notification"));
var _helpers = require("./helpers");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var _getQuestProjectLabel = (0, _helpers.getQuestProjectLabels)(),
  questProjectLabel = _getQuestProjectLabel.questProjectLabel,
  questProjectLabelPlural = _getQuestProjectLabel.questProjectLabelPlural,
  questAdminLabel = _getQuestProjectLabel.questAdminLabel,
  questAdminLabelPlural = _getQuestProjectLabel.questAdminLabelPlural;
var Boilerplate = window.cccisd.boilerplate;
var Fortress = window.cccisd.fortress;
var FormPermission = function FormPermission(_ref) {
  var settings = _ref.settings,
    row = _ref.row,
    onSubmit = _ref.onSubmit;
  var type = settings.type;
  var isProjectAdmin = type === 'questProjectAdmin';
  var _useState = (0, _react.useState)(null),
    _useState2 = _slicedToArray(_useState, 2),
    tableData = _useState2[0],
    setTableData = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = _slicedToArray(_useState3, 2),
    globalOn = _useState4[0],
    setGlobalOn = _useState4[1];
  var _useState5 = (0, _react.useState)([]),
    _useState6 = _slicedToArray(_useState5, 2),
    toggledByGlobal = _useState6[0],
    setToggledByGlobal = _useState6[1];
  var _useState7 = (0, _react.useState)(false),
    _useState8 = _slicedToArray(_useState7, 2),
    noQuestAdmins = _useState8[0],
    setNoQuestAdmins = _useState8[1];
  var permissions = [{
    permission: 'design',
    icon: _palette["default"],
    toolTipText: 'Design tab access',
    toggleDependsOn: true
  }, {
    permission: 'deploy',
    icon: _paperplane["default"],
    toolTipText: 'Deploy tab access',
    toggleDependsOn: true
  }, {
    permission: 'status',
    icon: _meterMedium["default"],
    toolTipText: 'Progress tab access',
    toggleDependsOn: true
  }, {
    permission: 'code',
    icon: _listNumbered["default"],
    toolTipText: 'Code tab access',
    toggleDependsOn: true
  }, {
    permission: 'view_data',
    icon: _fileSpreadsheet["default"],
    toolTipText: 'Data tab access'
  }, {
    permission: 'admin',
    icon: _cog["default"],
    toolTipText: "Full control over this ".concat(questProjectLabel, ", including Manage Projects tab access and ability to set permissions")
  }, {
    permission: 'copy_surveys',
    icon: _copy["default"],
    toolTipText: 'Copy surveys from this project into other projects',
    toggleDependsOn: true
  }, {
    permission: 'view_identifiable_data',
    icon: _userCheck["default"],
    toolTipText: 'View identifiable data'
  }, {
    permission: 'tables_edit',
    icon: _stackPlus["default"],
    toolTipText: 'Modify Queries'
  }, {
    permission: 'modify_data',
    icon: _pencil["default"],
    toolTipText: 'Delete Metrics'
  }];
  (0, _react.useEffect)(function () {
    getData();
  }, []);
  var getAdminTableData = function getAdminTableData(data) {
    var isGlobalAdmin = data.roles.globalAdminCheck.pawnPermission.pawnId;
    if (isGlobalAdmin) {
      setGlobalOn(true);
    }
    var _data$roles$questproj = data.roles.questprojectadmin,
      pawnPermissionList = _data$roles$questproj.pawnPermissionList,
      rolePermissionList = _data$roles$questproj.rolePermissionList;
    var projectList = data.groups.questprojectList;
    var adminTableData = projectList.map(function (project) {
      var columnValues = [{
        permission: 'projectName'
      }].concat(permissions).map(function (perm) {
        if (perm.permission === 'projectName') {
          return {
            permission: perm.permission,
            value: project.group.label
          };
        }

        // see if they have permission for a particular project
        var pawnMatch = pawnPermissionList.filter(function (item) {
          return item.targetId === project.group.groupId;
        }).find(function (item) {
          return item.permission === "quest.".concat(perm.permission);
        });
        var roleMatch = rolePermissionList.filter(function (item) {
          return item.targetId === project.group.groupId;
        }).find(function (item) {
          return item.permission === "quest.".concat(perm.permission);
        });
        if (roleMatch || pawnMatch) {
          return {
            permission: perm.permission,
            value: true
          };
        }
        return {
          permission: perm.permission,
          value: false
        };
      });
      var valuesWithToggle = addInitialToggleState(columnValues);
      return {
        actingHasPermToEdit: Fortress.hasAccess('quest.admin', project.group.groupId),
        row: {
          label: project.group.label,
          id: project.group.groupId
        },
        columns: valuesWithToggle
      };
    });
    return adminTableData;
  };
  var getProjectTableData = function getProjectTableData(data) {
    var questprojectadminList = data.roles.questprojectadminList;
    if (questprojectadminList.length === 0) {
      setNoQuestAdmins(true);
    }
    var projectTableData = questprojectadminList.map(function (admin) {
      var pawnPermissionList = admin.pawnPermissionList,
        rolePermissionList = admin.rolePermissionList;
      var columnValues = [{
        permission: 'username'
      }, {
        permission: 'firstName'
      }, {
        permission: 'lastName'
      }].concat(permissions).map(function (perm) {
        var textColumns = ['username', 'firstName', 'lastName'];
        if (textColumns.includes(perm.permission)) {
          return {
            permission: perm.permission,
            value: admin.user["".concat(perm.permission)]
          };
        }
        var pawnMatch = pawnPermissionList.find(function (item) {
          return item.permission === "quest.".concat(perm.permission);
        });
        var roleMatch = rolePermissionList.find(function (item) {
          return item.permission === "quest.".concat(perm.permission);
        });
        if (roleMatch || pawnMatch) {
          return {
            permission: perm.permission,
            value: true
          };
        }
        return {
          permission: perm.permission,
          value: false
        };
      });
      var valuesWithToggle = addInitialToggleState(columnValues);

      /* If pawn has "Full access to all Quest Projects", they
          cannot be edited here. That must be toggled off first. */
      var actingHasPermToEdit = !pawnPermissionList.find(function (perm) {
        return perm.permission === 'quest.admin' && !perm.targetId;
      }) && !rolePermissionList.find(function (perm) {
        return perm.permission === 'quest.admin' && !perm.targetId;
      });
      return {
        actingHasPermToEdit: actingHasPermToEdit,
        row: {
          id: admin.pawn.pawnId
        },
        columns: valuesWithToggle
      };
    });
    return projectTableData;
  };
  var addInitialToggleState = function addInitialToggleState(columns) {
    try {
      var toggleOn = false;
      // Permissions that affect initial toggle status
      var toggleOnPerms = ['design', 'deploy', 'status', 'code', 'view_data', 'admin', 'copy_surveys', 'view_identifiable_data', 'tables_edit', 'modify_data'];
      var filteredColumns = columns.filter(function (col) {
        return toggleOnPerms.includes(col.permission);
      });
      if (filteredColumns.some(function (col) {
        return col.value === true;
      })) {
        toggleOn = true;
      }
      return [{
        permission: 'toggle',
        value: toggleOn
      }].concat(columns);
    } catch (e) {
      console.error(e);
    }
  };
  var getData = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var queryPerms, variables, response, initialTableData;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            queryPerms = permissions.map(function (item) {
              return "quest.".concat(item.permission);
            });
            variables = isProjectAdmin ? {
              queryPerms: queryPerms,
              pawnId: row['pawn.pawnId'],
              questOrgId: row['ancestorGroups.questorganization.group.groupId']
            } : {
              queryPerms: queryPerms,
              projectId: row['group.groupId'],
              questOrg: row['ancestorGroups.questorganization.group.groupId']
            };
            _context.next = 4;
            return _cccisdApollo.client.query({
              query: isProjectAdmin ? _questAdmin["default"] : _questProject["default"],
              fetchPolicy: 'network-only',
              variables: variables
            });
          case 4:
            response = _context.sent;
            initialTableData = isProjectAdmin ? getAdminTableData(response.data) : getProjectTableData(response.data);
            setTableData(initialTableData);
          case 7:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function getData() {
      return _ref2.apply(this, arguments);
    };
  }();
  var getInitialValues = function getInitialValues() {
    var initialVals = {};
    tableData.forEach(function (item) {
      var id = item.row.id;
      var colValues = {};

      // for admin table modal
      var filteredColumns = item.columns.filter(function (col) {
        return col.permission !== 'projectName' || col.permission !== 'username' || col.permission !== 'firstName' || col.permission !== 'lastName';
      });
      // -------------------------
      filteredColumns.forEach(function (col) {
        if (col.value) {
          if (col.permission === 'toggle') {
            colValues.toggle = col.value;
          } else {
            colValues["".concat(col.permission)] = col.value;
          }
        }
      });
      initialVals["".concat(id)] = colValues;
    });
    if (globalOn) {
      initialVals.globalAdmin = true;
    }
    return initialVals;
  };
  var toggleOnChange = function toggleOnChange(event, field, form, kind) {
    var rowFields = ['design', 'deploy', 'status', 'code', 'copy_surveys'];
    var globalFields = ['view_data', 'admin', 'tables_edit', 'modify_data'];
    var toggleFields = rowFields.concat(globalFields);
    var id = field.name.split('.')[0];
    var toggledOn = !field.value;
    var toggledValues = {};
    if (kind === 'row') {
      if (toggledOn) {
        rowFields.forEach(function (item) {
          toggledValues["".concat(id)] = _objectSpread({}, toggledValues["".concat(id)]);
          toggledValues["".concat(id)]["".concat(item)] = true;
        });
      } else {
        ['view_identifiable_data'].concat(toggleFields).forEach(function (item) {
          toggledValues["".concat(id)] = _objectSpread({}, toggledValues["".concat(id)]);
          toggledValues["".concat(id)]["".concat(item)] = false;
        });
      }
    }
    if (kind === 'global') {
      if (toggledOn) {
        var initiallyOff = [];
        tableData.forEach(function (item) {
          toggledValues["".concat(item.row.id)] = _objectSpread({}, form.values["".concat(item.row.id)]);
          if (!item.columns[0].value) {
            initiallyOff.push(item.row.id);
          }
          toggledValues["".concat(item.row.id)].toggle = true;
        });
        setToggledByGlobal(initiallyOff);
      } else {
        toggledByGlobal.forEach(function (item) {
          var vals = {};
          toggleFields.forEach(function (perm) {
            vals[perm] = false;
          });
          toggledValues["".concat(item)] = vals;
          toggledValues["".concat(item)].toggle = false;
        });
      }
      setGlobalOn(function (prev) {
        return !prev;
      });
    }

    // toggle toggleFields
    form.setValues(_objectSpread(_objectSpread({}, form.values), toggledValues));

    // let toggle change its own value
    field.onChange(event);
  };
  var handleSubmit = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(values) {
      var payload, omitFields, nonIdentifiablePerms, _loop, _i, _Object$entries, _loop2, _i2, _Object$entries2, response, _response;
      return _regeneratorRuntime().wrap(function _callee2$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            payload = {};
            omitFields = ['projectName', 'username', 'firstName', 'lastName', 'toggle'];
            nonIdentifiablePerms = permissions.filter(function (perm) {
              return perm.permission !== 'view_identifiable_data';
            });
            if (!values.globalAdmin) {
              _context4.next = 13;
              break;
            }
            _loop = /*#__PURE__*/_regeneratorRuntime().mark(function _loop() {
              var _Object$entries$_i, key, value, perms;
              return _regeneratorRuntime().wrap(function _loop$(_context2) {
                while (1) switch (_context2.prev = _context2.next) {
                  case 0:
                    _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2), key = _Object$entries$_i[0], value = _Object$entries$_i[1];
                    perms = {};
                    nonIdentifiablePerms.forEach(function (perm) {
                      var permission = perm.permission;
                      perms["quest.".concat(permission)] = true;
                    });
                    if (key !== 'globalAdmin') {
                      payload["".concat(key)] = perms;
                    }
                    if (value.view_identifiable_data) {
                      payload["".concat(key)]["quest.view_identifiable_data"] = value.view_identifiable_data;
                    }
                  case 5:
                  case "end":
                    return _context2.stop();
                }
              }, _loop);
            });
            _i = 0, _Object$entries = Object.entries(values);
          case 6:
            if (!(_i < _Object$entries.length)) {
              _context4.next = 11;
              break;
            }
            return _context4.delegateYield(_loop(), "t0", 8);
          case 8:
            _i++;
            _context4.next = 6;
            break;
          case 11:
            _context4.next = 20;
            break;
          case 13:
            _loop2 = /*#__PURE__*/_regeneratorRuntime().mark(function _loop2() {
              var _Object$entries2$_i, key, value, hasAdminPerm, perms, _i3, _Object$entries3, _Object$entries3$_i, kee, val;
              return _regeneratorRuntime().wrap(function _loop2$(_context3) {
                while (1) switch (_context3.prev = _context3.next) {
                  case 0:
                    _Object$entries2$_i = _slicedToArray(_Object$entries2[_i2], 2), key = _Object$entries2$_i[0], value = _Object$entries2$_i[1];
                    hasAdminPerm = value.admin;
                    if (!(0, _isEmpty2["default"])(value)) {
                      perms = {};
                      if (hasAdminPerm) {
                        nonIdentifiablePerms.forEach(function (perm) {
                          var permission = perm.permission;
                          perms["quest.".concat(permission)] = true;
                        });
                        payload["".concat(key)] = perms;
                        if (value.view_identifiable_data) {
                          payload["".concat(key)]["quest.view_identifiable_data"] = value.view_identifiable_data;
                        }
                      } else {
                        for (_i3 = 0, _Object$entries3 = Object.entries(value); _i3 < _Object$entries3.length; _i3++) {
                          _Object$entries3$_i = _slicedToArray(_Object$entries3[_i3], 2), kee = _Object$entries3$_i[0], val = _Object$entries3$_i[1];
                          if (!omitFields.includes(kee)) {
                            perms["quest.".concat(kee)] = val;
                            payload["".concat(key)] = perms;
                          }
                        }
                      }
                    }
                  case 3:
                  case "end":
                    return _context3.stop();
                }
              }, _loop2);
            });
            _i2 = 0, _Object$entries2 = Object.entries(values);
          case 15:
            if (!(_i2 < _Object$entries2.length)) {
              _context4.next = 20;
              break;
            }
            return _context4.delegateYield(_loop2(), "t1", 17);
          case 17:
            _i2++;
            _context4.next = 15;
            break;
          case 20:
            if (!isProjectAdmin) {
              _context4.next = 34;
              break;
            }
            _context4.prev = 21;
            _context4.next = 24;
            return _cccisdAxios["default"].post(Boilerplate.route('api.assignment.questpermission.bulkProjectsForPawn', {
              pawn: row['pawn.pawnId']
            }), {
              globalQuestAdmin: values.globalAdmin,
              projects: payload
            });
          case 24:
            response = _context4.sent;
            if (response && response.data && response.data.status === 'success') {
              onSubmit();
              (0, _cccisdNotification["default"])({
                message: 'Permissions have been updated!',
                type: 'success'
              });
            }
            _context4.next = 32;
            break;
          case 28:
            _context4.prev = 28;
            _context4.t2 = _context4["catch"](21);
            (0, _cccisdNotification["default"])({
              message: 'An error occured updating permissions!',
              type: 'danger'
            });
            console.error(_context4.t2);
          case 32:
            _context4.next = 45;
            break;
          case 34:
            _context4.prev = 34;
            _context4.next = 37;
            return _cccisdAxios["default"].post(Boilerplate.route('api.assignment.questpermission.bulkPawnsForProject', {
              project: row['group.groupId']
            }), {
              pawns: payload
            });
          case 37:
            _response = _context4.sent;
            if (_response && _response.data && _response.data.status === 'success') {
              onSubmit();
              (0, _cccisdNotification["default"])({
                message: 'Permissions have been updated!',
                type: 'success'
              });
            }
            _context4.next = 45;
            break;
          case 41:
            _context4.prev = 41;
            _context4.t3 = _context4["catch"](34);
            (0, _cccisdNotification["default"])({
              message: 'An error occured updating permissions!',
              type: 'danger'
            });
            console.error(_context4.t3);
          case 45:
          case "end":
            return _context4.stop();
        }
      }, _callee2, null, [[21, 28], [34, 41]]);
    }));
    return function handleSubmit(_x) {
      return _ref3.apply(this, arguments);
    };
  }();
  var isGlobalToggleDisabled = tableData === null || tableData === void 0 ? void 0 : tableData.some(function (qp) {
    return !qp.actingHasPermToEdit;
  });
  var renderTableForm = function renderTableForm() {
    return /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Formik, {
      onSubmit: handleSubmit,
      initialValues: getInitialValues(),
      render: function render(formikProps) {
        return /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Form, null, /*#__PURE__*/_react["default"].createElement("table", {
          className: "".concat(isProjectAdmin ? _style["default"].formTableAdmin : _style["default"].formTableProject, " table table-bordered table-striped table-condensed")
        }, /*#__PURE__*/_react["default"].createElement("thead", null, /*#__PURE__*/_react["default"].createElement("tr", null, /*#__PURE__*/_react["default"].createElement("th", {
          className: _style["default"].rowToggle,
          rowSpan: 2
        }, "Actions"), isProjectAdmin ? /*#__PURE__*/_react["default"].createElement("th", {
          className: _style["default"].projectName,
          rowSpan: 2
        }, questProjectLabelPlural) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("th", {
          rowSpan: 2
        }, "Username"), /*#__PURE__*/_react["default"].createElement("th", {
          rowSpan: 2
        }, "First Name"), /*#__PURE__*/_react["default"].createElement("th", {
          rowSpan: 2
        }, "Last Name")), /*#__PURE__*/_react["default"].createElement("th", {
          colSpan: 6,
          style: {
            textAlign: 'center'
          }
        }, "Tabs"), /*#__PURE__*/_react["default"].createElement("th", {
          colSpan: 4,
          style: {
            textAlign: 'center'
          }
        }, "Permissions")), /*#__PURE__*/_react["default"].createElement("tr", null, permissions.map(function (item, i) {
          var Icon = item.icon;
          return /*#__PURE__*/_react["default"].createElement("th", {
            key: i,
            style: {
              textAlign: 'center'
            }
          }, /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
            title: item.toolTipText,
            placement: "top"
          }, /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement(Icon, null))));
        }))), /*#__PURE__*/_react["default"].createElement("tbody", null, tableData.sort(function (a, b) {
          if (a.actingHasPermToEdit === b.actingHasPermToEdit) {
            if (isProjectAdmin) {
              return a.row.label.localeCompare(b.row.label);
            }
            // Data structure is dicey. Wrap in try catch so it doesn't white screen
            try {
              return a.columns.find(function (col) {
                return col.permission === 'username';
              }).value.localeCompare(b.columns.find(function (col) {
                return col.permission === 'username';
              }).value);
            } catch (e) {
              return 0;
            }
          }
          if (a.actingHasPermToEdit) {
            return -1;
          }
          if (b.actingHasPermToEdit) {
            return 1;
          }
          return 0;
        }).map(function (item, i) {
          var hasAdminPerm = formikProps.values[item.row.id].admin === true || formikProps.values.globalAdmin === true;
          var actingHasPermToEdit = item.actingHasPermToEdit;
          return /*#__PURE__*/_react["default"].createElement("tr", {
            key: i,
            className: !actingHasPermToEdit ? _style["default"].disabledRow : ''
          }, item.columns.map(function (col, id) {
            if (col.permission === 'toggle') {
              return /*#__PURE__*/_react["default"].createElement("td", {
                key: id
              }, globalOn ? /*#__PURE__*/_react["default"].createElement("div", {
                className: _style["default"].toggleCheckmark
              }, /*#__PURE__*/_react["default"].createElement(_checkmark["default"], null)) : /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
                name: "".concat(item.row.id, ".toggle")
              }, function (_ref4) {
                var field = _ref4.field,
                  form = _ref4.form;
                return /*#__PURE__*/_react["default"].createElement(_cccisdFormik.CccisdFieldWrapper, {
                  field: field,
                  form: form
                }, /*#__PURE__*/_react["default"].createElement(_cccisdToggle["default"], _extends({}, field, {
                  disabled: !actingHasPermToEdit,
                  onChange: function onChange(e) {
                    if (actingHasPermToEdit) {
                      toggleOnChange(e, field, form, 'row');
                    }
                  }
                })));
              }));
            }
            if (col.permission === 'projectName') {
              return /*#__PURE__*/_react["default"].createElement("td", {
                className: _style["default"].projectNameBreak,
                key: id
              }, col.value);
            }
            if (col.permission === 'firstName' || col.permission === 'lastName') {
              return /*#__PURE__*/_react["default"].createElement("td", {
                className: _style["default"].firstLasNameBreak,
                key: id
              }, col.value);
            }
            if (col.permission === 'username') {
              return /*#__PURE__*/_react["default"].createElement("td", {
                className: _style["default"].userNameBreak,
                key: id
              }, col.value);
            }
            if (col.permission === 'view_identifiable_data') {
              return globalOn || formikProps.values["".concat(item.row.id)].toggle ? /*#__PURE__*/_react["default"].createElement("td", {
                key: id,
                className: _style["default"].center
              }, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
                name: "".concat(item.row.id, ".").concat(col.permission),
                component: _cccisdFormik.CccisdCheckboxInput,
                disabled: !actingHasPermToEdit,
                label: "",
                labelNotBold: true
              })) : /*#__PURE__*/_react["default"].createElement("td", {
                key: id
              });
            }
            if (globalOn) {
              return /*#__PURE__*/_react["default"].createElement("td", {
                key: id
              }, /*#__PURE__*/_react["default"].createElement("div", {
                className: _style["default"].checkmark
              }, /*#__PURE__*/_react["default"].createElement(_checkmark["default"], null)));
            }
            if (!formikProps.values["".concat(item.row.id)].toggle) {
              return /*#__PURE__*/_react["default"].createElement("td", {
                key: id
              });
            }
            if (hasAdminPerm && col.permission !== 'admin') {
              return /*#__PURE__*/_react["default"].createElement("td", {
                key: id
              }, /*#__PURE__*/_react["default"].createElement("div", {
                className: _style["default"].checkmark
              }, /*#__PURE__*/_react["default"].createElement(_checkmark["default"], null)));
            }
            return /*#__PURE__*/_react["default"].createElement("td", {
              key: id,
              className: _style["default"].center
            }, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
              name: "".concat(item.row.id, ".").concat(col.permission),
              component: _cccisdFormik.CccisdCheckboxInput,
              label: "",
              labelNotBold: true,
              disabled: globalOn || !actingHasPermToEdit
            }));
          }));
        }))), isGlobalToggleDisabled && /*#__PURE__*/_react["default"].createElement("p", {
          className: 'help-block ' + _style["default"].disabledRowsHelperText
        }, isProjectAdmin ? "You do not have permission to administer all ".concat(questProjectLabelPlural, ".") : "Permissions for ".concat(questAdminLabelPlural, " who have full access across all ").concat(questProjectLabelPlural, " cannot be changed here.")), isProjectAdmin && (!isGlobalToggleDisabled || globalOn) && /*#__PURE__*/_react["default"].createElement("div", {
          className: _style["default"].globalButton
        }, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
          name: "globalAdmin"
        }, function (_ref5) {
          var field = _ref5.field,
            form = _ref5.form;
          return /*#__PURE__*/_react["default"].createElement(_cccisdFormik.CccisdFieldWrapper, {
            field: field,
            form: form
          }, /*#__PURE__*/_react["default"].createElement(_cccisdToggle["default"], _extends({}, field, {
            disabled: isGlobalToggleDisabled,
            onChange: function onChange(e) {
              if (!isGlobalToggleDisabled) {
                toggleOnChange(e, field, form, 'global');
              }
            }
          })));
        }), ' ', /*#__PURE__*/_react["default"].createElement("span", {
          className: "".concat(_style["default"].spaceLeft, " ").concat(isGlobalToggleDisabled ? _style["default"].disabledRow : '')
        }, "Full access to all ", questProjectLabelPlural)), /*#__PURE__*/_react["default"].createElement("button", {
          className: "btn btn-primary",
          type: "submit"
        }, "Submit"));
      }
    });
  };
  if (!tableData) {
    return null;
  }
  if (noQuestAdmins) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "alert alert-warning",
      style: {
        textAlign: 'center'
      }
    }, /*#__PURE__*/_react["default"].createElement("p", null, "There are no ", questAdminLabelPlural, " assigned to this ", questProjectLabel, "'s Organization."), /*#__PURE__*/_react["default"].createElement("p", null, "Please assign a ", questAdminLabel, " to the ", questProjectLabel, "'s Organization to grant permissions for this ", questProjectLabel, "."));
  }
  return renderTableForm();
};
var _default = exports["default"] = FormPermission;